const REQUIRED_ENV_KEYS: string[] = []

const env = import.meta.env

export function validateEnv() {
  for (const key of REQUIRED_ENV_KEYS) {
    const value = env[key]
    if (typeof value === "undefined") {
      throw new Error(`Missing required environment variable: ${key}`)
    }
  }
}

export const IS_DEV = env.DEV
export const API_BASE_URL: string = env.VITE_BASE_API_URL ?? "/api"
export const BASE_URL: string = env.VITE_BASE_URL ?? "/"
